import { Injectable } from "@angular/core";
import { ModalService } from "../../core/core";
import { VideoModalComponent } from "../components/video-modal/video-modal.component";

@Injectable({
  providedIn: "root",
})
export class VideoModalService {
  constructor(private modalService: ModalService) {}

  create(url: string) {
    const modalRef = this.modalService.extraLargeModal(VideoModalComponent, false);
    modalRef.componentInstance.videoUrl = url;
    return modalRef;
  }
}
